var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3257_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.76 0H31.24C36.0781 0 40 3.92187 40 8.76V31.24C40 36.0781 36.0781 40 31.24 40H8.76C3.92187 40 0 36.0781 0 31.24V8.76C0 3.92187 3.92187 0 8.76 0Z",
    fill: "url(#paint0_linear_3257_14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8195 29.0326L12.8233 29.0338L11.4556 31.4026C10.9564 32.2673 9.85078 32.5635 8.98609 32.0643C8.12141 31.5651 7.82516 30.4595 8.32437 29.5948L9.33188 27.8498L9.42859 27.6823C9.60125 27.4341 10.0273 27.0057 10.8797 27.0863C10.8797 27.0863 12.8855 27.304 13.0306 28.3465C13.0306 28.3465 13.0503 28.6895 12.8195 29.0326ZM32.2169 22.9826H27.9522C27.6617 22.963 27.535 22.8593 27.485 22.799L27.4819 22.7935L22.9167 14.8863L22.9108 14.8902L22.637 14.4977C22.1883 13.8115 21.4758 15.5665 21.4758 15.5665C20.625 17.5221 21.5966 19.7454 21.9352 20.4174L28.2761 31.4002C28.7752 32.2648 29.8808 32.5612 30.7456 32.0618C31.6102 31.5626 31.9066 30.457 31.4072 29.5923L29.8217 26.846C29.7909 26.7794 29.7375 26.5988 30.0627 26.598H32.2169C33.2153 26.598 34.0247 25.7887 34.0247 24.7902C34.0247 23.7918 33.2153 22.9826 32.2169 22.9826ZM23.9334 25.4399C23.9334 25.4399 24.1611 26.5979 23.2803 26.5979H7.51484C6.51641 26.5979 5.70703 25.7885 5.70703 24.7901C5.70703 23.7916 6.51641 22.9823 7.51484 22.9823H11.568C12.2223 22.9444 12.3773 22.5666 12.3773 22.5666L12.3811 22.5685L17.6717 13.4048L17.6702 13.4044C17.7666 13.2274 17.6863 13.0601 17.6723 13.0337L15.925 10.0073C15.4258 9.14273 15.722 8.03695 16.5867 7.53789C17.4514 7.03882 18.557 7.33476 19.0562 8.19945L19.8666 9.60304L20.6755 8.20195C21.1747 7.33742 22.2803 7.04101 23.145 7.54039C24.0097 8.03976 24.3059 9.14508 23.8067 10.0098L16.4445 22.7613C16.4123 22.839 16.4025 22.9609 16.642 22.9823H21.0427L21.0436 23.0252C21.0436 23.0252 23.587 23.0648 23.9334 25.4399Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3257_14",
    x1: 2000,
    y1: 0,
    x2: 2000,
    y2: 4000,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17C9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A74E8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3257_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/App Store.e604a1c8b69b793e4d6e0f5f415b62f8.svg";
export { ForwardRef as ReactComponent };